import React, { forwardRef } from 'react';
import { FormControl as LegacyFormControl } from './component.legacy';
import { FormControl as NewFormControl, FormControlHandle, FormControlProps } from './component';

export type { FormControlHandle } from './component';
export type { FormControlProps } from './component';

export interface FormControlBridgeProps extends FormControlProps {
  renderAsLegacy?: boolean;
}

/**
 * Bridge: set renderAsLegacy={false} to opt in to the new functional implementation.
 * Defaults to legacy to preserve existing behaviour.
 * Uses forwardRef so that FormField can access the control's imperative handle (isValid, checkError).
 */
export const FormControl = forwardRef<FormControlHandle, FormControlBridgeProps>(
  ({ renderAsLegacy = true, ...restProps }, ref) => {
    const Component: typeof LegacyFormControl | typeof NewFormControl = renderAsLegacy
      ? LegacyFormControl
      : NewFormControl;
    return <Component {...restProps} ref={ref as React.Ref<FormControlHandle>} />;
  }
);

(FormControl as React.ForwardRefExoticComponent<unknown>).displayName = 'FormControl';
